/**
 * Dynamically loads an external JavaScript file.
 * @param src - URL of the script to load
 * @returns A Promise that resolves when the script is loaded
 */
export function loadExternalScript(src: string): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    // Avoid loading the same script more than once
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve(
        document.querySelector(`script[src="${src}"]`) as HTMLScriptElement,
      );
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(script);
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

    document.head.appendChild(script);
  });
}
